import { AfterViewInit, ChangeDetectorRef, Component, forwardRef, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { Language } from 'app/model/constant';
import { FleetCardOption, FleetCardType } from 'app/model/fleet/fleet.model';
import { AppConfigService } from 'app/services/app-config/app-config.service';
import { UtilitiesService } from 'app/services/utilities/utilities.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'act-fleet-card-select-box',
  templateUrl: './fleet-card-select-box.component.html',
  styleUrls: ['./fleet-card-select-box.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FleetCardSelectBoxComponent),
      multi: true
    }
  ]
})
export class FleetCardSelectBoxComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges {

  @Input() setElementIdPage = 'fleet-card-select-box';
  @Input() optionList: FleetCardOption[] = [];
  @Input() isError = false;
  @Input() defaultValue = 'Please select';

  public FleetCardType = FleetCardType;
  public Language = Language;
  public selectBoxWidth = '0';
  public isMobile = false;
  public lang: string;
  public isOpenMenu = false;

  public onChange: Function;
  public onTouch: Function;
  public value = '';
  public currentOption: FleetCardOption;

  private langSubscription: Subscription;

  constructor(
    private utilitiesService: UtilitiesService,
    private appConfigService: AppConfigService,
    private cdr: ChangeDetectorRef,
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.optionList) {
      if (changes.optionList.currentValue) {
        if (this.value) {
          const newOption = changes.optionList.currentValue.find(item => item.fleetCardId === this.value);
          this.currentOption = newOption;
          if (newOption) {
            this.value = newOption.fleetCardId;
          }
        }
      }
    }
  }

  ngOnInit() {
    this.isMobile = this.utilitiesService.isMobile();
    this.lang = this.appConfigService.getLanguage();
    this.langSubscription && this.langSubscription.unsubscribe();
    this.langSubscription = this.appConfigService.getLanguageObs()
      .subscribe(lang => this.lang = lang);
  }

  ngAfterViewInit() {
    if (document.getElementById(`${this.setElementIdPage}-select-box`).clientWidth === 0) {
      this.selectBoxWidth = window.innerWidth - 18 + 'px';
    } else {
      this.selectBoxWidth = (document.getElementById(`${this.setElementIdPage}-select-box`).clientWidth + 2) + 'px';
    }
    this.cdr.detectChanges();
  }

  ngOnDestroy() {
    this.langSubscription && this.langSubscription.unsubscribe();
  }

  writeValue(value: string) {
    this.value = value;
    this.optionList && this.optionList.length > 0 && this.onSelect(value);
  }

  registerOnChange(onChange: Function) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouch: Function) {
    this.onTouch = onTouch;
  }

  onSelect(value: string) {
    const newOption = this.optionList.find(item => item.fleetCardId === value);
    if (this.currentOption !== newOption) {
      this.currentOption = newOption;
      if (newOption) {
        this.value = newOption.fleetCardId;
      }
      this.onChange && this.onChange(this.value);
    }
  }

  onOpenMenu() {
    this.isOpenMenu = true;
  }

  onCloseMenu() {
    this.isOpenMenu = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/components/fleet-card-select-box/fleet-card-select-box.component.ts